const getIsUserStripeSubscriptionActive = (user) => user && user.subscription_status === 'active';

export { getIsUserStripeSubscriptionActive };
